import { render, staticRenderFns } from "./ServicePage2.vue?vue&type=template&id=4d363061&scoped=true"
import script from "./ServicePage2.vue?vue&type=script&lang=js"
export * from "./ServicePage2.vue?vue&type=script&lang=js"
import style0 from "./ServicePage2.vue?vue&type=style&index=0&id=4d363061&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d363061",
  null
  
)

export default component.exports